import { Component, Input } from "@angular/core";
import { SearchStatus } from "apps-module/app/shared-library/enums/search-status.enum";

@Component({
    selector: "[pcg-ng-search-message]",
    templateUrl: "./search-message.component.html",
    providers: []
})
export class SearchMessageComponent {

    @Input()
    public extraText: string = null;
    @Input()
    public extraLinkUrl: string = null;
    @Input()
    public extraLinkText: string = null;
    @Input()
    public extraLinkTarget: string = null;

    @Input()
    public searchText: string = null;

    @Input()
    public totalCount: number = 0;

    public readonly statuses = SearchStatus;

    @Input()
    public searchStatus: SearchStatus = SearchStatus.Loading;
}
